import {
  BlockRounded,
  CrisisAlertRounded,
  CurrencyExchangeRounded,
  HomeRounded,
  LocalPrintshopRounded,
} from "@mui/icons-material";
import { Paper } from "@mui/material";
import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../App";
import { Button } from "../../../controls";
import { PrintDiv, ToFormData } from "../../../hooks/Method";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../../layout";
import ReturnDialog from "../../sellReturn/ReturnDialog";
import { action, controller, Server } from "../../../api/Server";
import { CartContext } from "../Pos";

const Actions = (props) => {
  const { handleClearCart, setReceptData, cartItems, subTotal, tax, setAlert } =
    props;
  const { editSale, setEditSale, quote } = useContext(CartContext);
  const { setCLoader, selStore, authUser } = useContext(AppContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [refundForm, setRefundForm] = useState(false);

  const handlePrintLastSale = () => {
    const onComplete = (res) => {
      if (res.status === 200 && res.result !== null) {
        setReceptData(res.result);
        setTimeout(() => {
          PrintDiv("printSellRecept");
          setCLoader(false);
        }, 1000);
      } else if (res.result === null)
        setAlert({
          isOpen: true,
          type: "warning",
          title: t("warning"),
          subTitle: t("thereIsNoLastSaleData"),
        });
    };
    Server(controller.Sell + action.GetLastSell).getById(selStore, onComplete);
  };

  const handleVoidSell = () => {
    const voidVal = {
      items: cartItems.map((j) =>
        j.itemType === 2 ? { ...j, productId: "" } : j
      ),
      tax: tax,
      cancelType: 1,
      subtotal: subTotal,
      userId: authUser.id,
      storeId: selStore,
    };
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("areYouSure"),
      subTitle: t("youWantToVoidThisSell"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res.status === 201) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("successful"),
              subTitle: t("youHaveSuccessfullyVoidThisSale"),
            });
            handleClearCart();
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: t("warning"),
              subTitle: res.msg,
            });
          }
        };
        Server(controller.VoidSell).post(
          ToFormData({ ...voidVal, date: new Date().toISOString() }),
          onComplete
        );
      },
    });
  };

  const handleRefund = () => {
    setRefundForm(!refundForm);
  };

  const handleCancelEdit = () => {
    localStorage.removeItem("sellId");
    setEditSale({});
    handleClearCart();
  };

  return (
    <>
      <Paper
        className="shadow-xs p-10 d-flex g-10"
        sx={{
          minHeight: "50px",
          borderRadius: "20px",
          flexWrap: { xs: "wrap", md: "inherit" },
        }}
      >
        <Button
          onClick={() => navigate("/pos")}
          variant="text"
          fullWidth
          sx={{
            display: "block",
            "& .MuiButton-startIcon": { mr: 0, ml: 0, lineHeight: 0 },
          }}
          startIcon={<HomeRounded className="fs-26" />}
        >
          <span className="fs-12">{t("home")}</span>
        </Button>
        <Button
          onClick={handlePrintLastSale}
          variant="text"
          fullWidth
          sx={{
            display: "block",
            "& .MuiButton-startIcon": { mr: 0, ml: 0, lineHeight: 0 },
          }}
          startIcon={<LocalPrintshopRounded className="fs-22" />}
        >
          <span className="fs-12">{t("printLastSale")}</span>
        </Button>
        {(editSale && editSale.id) || (quote && quote.id) ? (
          <Button
            onClick={handleCancelEdit}
            variant="text"
            fullWidth
            color="error"
            className="error-color bg-errorSM"
            sx={{
              display: "block",
              "& .MuiButton-startIcon": { mr: 0, ml: 0, lineHeight: 0 },
            }}
            startIcon={<BlockRounded className="fs-22" />}
          >
            <span className="fs-12">{t("cancel")}</span>
          </Button>
        ) : (
          <Button
            onClick={handleVoidSell}
            variant="text"
            fullWidth
            sx={{
              display: "block",
              "& .MuiButton-startIcon": { mr: 0, ml: 0, lineHeight: 0 },
            }}
            startIcon={<CrisisAlertRounded className="fs-22" />}
          >
            <span className="fs-12">{t("voidSell")}</span>
          </Button>
        )}

        <Button
          onClick={handleRefund}
          variant="text"
          fullWidth
          sx={{
            display: "block",
            "& .MuiButton-startIcon": { mr: 0, ml: 0, lineHeight: 0 },
          }}
          startIcon={<CurrencyExchangeRounded className="fs-22" />}
        >
          <span className="fs-12">{t("sellReturn")}</span>
        </Button>
      </Paper>

      {/* Refund Form */}
      {refundForm && (
        <Dialog show={refundForm} onClose={false} maxWidth="xs">
          <ReturnDialog {...{ setShowForm: setRefundForm }} />
        </Dialog>
      )}
    </>
  );
};

export default Actions;
